<div class="ask-contact buttononly {{wrapperclass}}" [ngClass]="checkingForAfChannel$()" [class.active]="checkingForAfChannel$()"
[class.offline]="checkingForAfChannel$() === 'offline'"
[class.livechat]="checkingForAfChannel$() === 'livechat'"
[class.connecting]="checkingForAfChannel$() === 'In connessione ...'"
[class.fw]="buttonfw">
<ng-container [ngSwitch]="buttonType">
    <ng-container *ngSwitchCase="'flat'">
        <button mat-flat-button
            (click)="getReportSubmit(true)" color="primary" class="p-button button-ask" *ngIf="!checkingForAfChannel$()" [class.fw]="buttonfw" [ngClass]="buttonclass">
                {{ buttonlabel | translate}}
    </button>
    </ng-container> 
    <ng-container *ngSwitchCase="'stroked'">
        <button mat-stroked-button
        (click)="getReportSubmit(true)" color="primary" class="p-button button-ask" *ngIf="!checkingForAfChannel$()" [class.fw]="buttonfw" [ngClass]="buttonclass" >
            {{ buttonlabel | translate}}
        </button>
    </ng-container>
    <ng-container *ngSwitchCase="'raised'">
        <button mat-raised-button
        (click)="getReportSubmit(true)" color="primary" class="p-button button-ask" *ngIf="!checkingForAfChannel$()" [class.fw]="buttonfw" [ngClass]="buttonclass" >
            {{ buttonlabel | translate}}
        </button>
    </ng-container>
    <ng-container *ngSwitchCase="'icon'">
        <button mat-icon-button
        (click)="getReportSubmit(true)" color="primary" class="p-button button-ask" *ngIf="!checkingForAfChannel$()" [class.fw]="buttonfw" [ngClass]="buttonclass" 
        >
            {{ buttonlabel | translate}}
        </button>
    </ng-container>
    <ng-container *ngSwitchCase="'base'">
        <button mat-button
        (click)="getReportSubmit(true)" color="primary" class="p-button button-ask" *ngIf="!checkingForAfChannel$()" [class.fw]="buttonfw" [ngClass]="buttonclass" >
            {{ buttonlabel | translate}}
        </button>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <button mat-button
        (click)="getReportSubmit(true)" color="primary" class="p-button button-ask" *ngIf="!checkingForAfChannel$()" [class.fw]="buttonfw" [ngClass]="buttonclass" >
            {{ buttonlabel | translate}}
        </button>
    </ng-container>
</ng-container>
    <div class="connection-animation-wrapper d-flex flex-column" *ngIf="checkingForAfChannel$()">
        <div class="message-connecting" *ngIf="checkingForAfChannel$() === 'In connessione ...'">{{'Ti stiamo connettendo in chat con un consulente dedicato ... ' | translate }}</div>
        <div class="connection-animation " >
            <div class="ani d-flex gap-8">
                <div class="di di-3x di-chat"></div>
                <div class="dots">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                </div>
                <div class="di di-3x"
                    [ngClass]="{'di-assistance': checkingForAfChannel$() === 'livechat', 'di-edit': checkingForAfChannel$() === 'offline' }">
                </div>
            </div>
            <div class="connectionstatus text-uppercase">
                {{ checkingForAfChannel$()}}
            </div>

        </div>
    </div>
</div>
